export const config = {
  API_URL: 'https://devoretapi.co.uk/api/',
  API2: 'https://devoretapi.co.uk/api/v1/',
  API_URL_ADMIN: 'https://devoretapi.co.uk/api/admin/',
  socketAPI: 'https://epos.devoretapi.co.uk',
 // API_URL:'http://localhost:8000/api/'
}
